<template>
  <Layout>
    <template #header>
      <Heading>
        {{ $t('ppm_modal__select_method_heading') }}
      </Heading>
    </template>

    <template #default>
      <div class="spm-main">
        <div class="spm-cards">
          <b-radio
            v-for="account in paymentAccounts"
            :key="account.entity_payment.entity_payment_uuid"
            v-model="selectedEntityPaymentUuid"
            name="payment-method"
            :native-value="account.entity_payment.entity_payment_uuid"
            class="spm-card-radio"
          >
            <component
              :is="getCardComponent(account)"
              class="spm-card"
              :class="{
                'spm-card-selected':
                  account.entity_payment.entity_payment_uuid ===
                  selectedEntityPaymentUuid,
              }"
              v-bind="getCardProps(account)"
            />
          </b-radio>
        </div>
      </div>
    </template>

    <template #vertical-footer>
      <HotPinkButton
        :disabled="!selectedEntityPaymentUuid"
        class="spm-button"
        data-testid="save-ppm-button"
        @click="
          $emit('save-preferred-payment-method', selectedEntityPaymentUuid)
        "
      >
        {{ $t('ppm_modal__select_method_confirm_button') }}
      </HotPinkButton>
      <NavyButton
        class="spm-button"
        data-testid="add-new-ppm-button"
        @click="$emit('go-to-add-payment-method')"
      >
        {{ $t('ppm_modal__select_method_cancel_button') }}
      </NavyButton>
    </template>
  </Layout>
</template>

<script>
import Layout from '../layouts/Layout.vue'
import Heading from '../typography/Heading3.vue'
import HotPinkButton from '../buttons/HotPinkButton.vue'
import NavyButton from '../buttons/NavyButton.vue'
import CardMixin from '../mixins/CardMixin'
import PaymentFlagsMixin from '../mixins/PaymentFlagsMixin'

export default {
  components: {
    Layout,
    Heading,
    HotPinkButton,
    NavyButton,
  },
  mixins: [CardMixin, PaymentFlagsMixin],
  data() {
    return {
      selectedEntityPaymentUuid: null,
      paymentAccounts: [],
    }
  },
  created() {
    this.getAccounts()
  },
  methods: {
    async getAccounts() {
      this.paymentAccounts = await this.getPaymentAccounts()
    },
  },
}
</script>

<style lang="postcss" scoped>
.spm-main {
  /* Base */
  @apply tw-mt-8 tw-mb-1;
}

.spm-cards {
  /* Base */
  @apply tw-flex tw-flex-col tw-gap-2;

  /* Desktop */
  @apply lg:tw-items-center lg:tw-gap-4;
}

.spm-card-radio {
  /* Base */
  @apply !tw-m-0;

  /* Desktop */
  @apply lg:!tw-ml-[-31px];
}

.spm-card-radio >>> .control-label {
  /* Base */
  @apply tw-flex-1;
}

.spm-card {
  /* Desktop */
  @apply lg:tw-w-[336px];
}

.spm-card-selected {
  /* Base */
  box-shadow: 0 0 0 2.7px #325cf3;
  filter: drop-shadow(2px 2px 4px rgba(0, 0, 0, 0.25));
}

.spm-button {
  /* Desktop */
  @apply lg:tw-w-[336px];
}
</style>
